import $ from 'jquery';
import 'bootstrap/js/dist/modal';

function clearAllModalTimeouts() {
    for (let i = 0; i < window.modalTimeouts.length; i++) clearTimeout(window.modalTimeouts[i]);
}

function initFocusPreservationOnModalClose() {
    window.lastFocus = document.body;
    const $modal = $('#js-modal');
    $modal.on('show.bs.modal', () => window.lastFocus = document.activeElement);
    $modal.on('hidden.bs.modal', () => window.lastFocus.focus());
}

export function openForElement($element) {
    clearAllModalTimeouts();

    const modalText = $element.closest('.form-check').find('.js-modal-text').html();
    $('#js-modal-body').html(modalText);
    $('#js-modal').modal('show');
}

function onInputChange() {
    const $triggers = $('.js-has-modal-triggers input');
    if ($triggers.length < 1) return;

    function addModalTimeout($element, ms) {
        const id = setTimeout(function () {
            openForElement($element);
        }, ms);

        window.modalTimeouts.push(id);
    }

    // TODO: maybe specify this event only to RadioButtons & Checkboxes
    $triggers.on('change', function () {
        const $this = $(this);

        clearAllModalTimeouts();

        if (!$this.hasClass('js-modal-trigger')) return;

        let timeoutMs = window.isLastActionClick ? 0 : 1000;
        if ($this.is(':checkbox')) {
            if ($this.prop('checked')) timeoutMs = 0;
            else return;
        }

        if (timeoutMs === 0) openForElement($this);
        else addModalTimeout($this, timeoutMs);
    });

    // TODO: dropdowns
}

export function initEvents() {
    onInputChange(); // or: onInputOrSelectChange()
    // onSelectChange()

    initFocusPreservationOnModalClose();
}

export default {
    openForElement,
    initEvents
};
